import { useState, useEffect, useContext } from 'react'
import { Link, useLocation, useParams } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { RxLapTimer } from "react-icons/rx";


import Task from "./Task"; 
import { DateToText } from "../../../inc/Fetch"; 

import './css/Ready.css'

export default function Ready({ data, onChange }) {

    const [countDown, setcountDown] = useState(false);
    function start() {
        setcountDown(1);

        setTimeout(() => {
            setcountDown(2);
        }, 1000);

        setTimeout(() => {
            setcountDown(3);
        }, 2000);

        setTimeout(() => {
            onChange("start");
        }, 3000);
        
    }

    

    const { t } = useTranslation();
    return (
        <div className='readyToStartBox '>
            <div className={`readyToStartBody shadow ${countDown && "hide" }`}>
                {/* <Task v={data} /> */}
                <div className='readyTaskInfo'>
                    <h3>{data?.title}</h3>
                    <span>{data?.task?.cat?.name} - {t("tasks_sent_date")}: <DateToText time={data?.date} /></span>

                    <p>{data?.notes}</p>

                    <table className='table'>
                        <tbody>
                            {data?.start_date && <tr>
                                <td style={{width:'30%'}} className='text-right'>{t("score_info_1")}</td>
                                <td className='text-right'><DateToText time={data?.start_date} /></td>
                            </tr>}

                            {data?.end_date && <tr>
                                <td className='text-right'>{t("score_info_2")}</td>
                                <td className='text-right'><DateToText time={data?.end_date} /></td>
                            </tr>}

                            <tr>
                                <td className='text-right'>{t("tasks_send_timer")}</td>
                                <td className='text-right'>{data?.timer?.name}</td>
                            </tr>

                            <tr>
                                <td className='text-right'>{t("tasks_questions_number")}</td>
                                <td className='text-right'>{data?.questions?.length}</td>
                            </tr>

                            <tr>
                                <td className='text-right'>{t("tasks_check_nswers")}</td>
                                <td className='text-right'>{data?.answers_result?.name}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div style={{display:"flex", alignItems:"center"}}>
                    <button className='btn gray' onClick={() => onChange("cancel")} style={{flex:0}}>{t("cancel")}</button>
                    <button className='btn' onClick={start} style={{flex:1}}>{t("tasks_start")}</button>
                </div>
            </div>

            <div className='numbersBox'>
                <li className={countDown == 1 ? "ck" : false}>1</li>
                <li className={countDown == 2 ? "ck" : false}>2</li>
                <li className={countDown == 3 ? "ck" : false}>3</li>
            </div>
        </div>
    )
}



export function TimeEnded() {

    const { t } = useTranslation();

    return (
        <div className='readyToStartBox '>
            <div className={`readyToStartBody shadow timeEnded`}>
                <RxLapTimer />

                <p>{t("tasks_time_ended_title")}</p>
                
                <div style={{display:"flex", alignItems:"center"}}>
                    <button className='btn' onClick={() => window.location.reload()} style={{flex:1}}>{t("tasks_time_ended_btn")}</button>
                </div>
            </div>
        </div>
    )
}

export function ScoreView({score}) {

    const { t } = useTranslation();

    return (
        <div className='readyToStartBox '>
            <div className={`readyToStartBody shadow scoreView`}>
                
                <div style={{padding:20, display:"flex", flexDirection:"column"}}>

                    <b>{score}%</b>
                    <span>{t("task_student_status_2")}</span>

                    <h2>{t("score_ready_title")}</h2>
                    
                    <p>{t("score_ready_short")}</p>
                </div>


                <div style={{display:"flex", alignItems:"center"}}>
                    <Link to='/myTasks' className='btn' style={{flex:1}}>{t("prev")}</Link>
                </div>
            </div>
        </div>
    )
}


export function ScoreAndNotes({ score, note, onChange }) {
    const { t } = useTranslation();

    function notes(e) {
        if (typeof onChange !== 'undefined'){
            onChange(e?.target?.value)
        }
    }
    
    const [sc, setsc] = useState(score || 0)

    return (
        <div className='questionTaskResultBox'>
            <textarea onChange={notes} defaultValue={note} placeholder={`${t("task_note")}...`}></textarea>
            <div>
                <span>{t("tasks_question_score")}</span>
                <input type='number' value={sc} disabled />
            </div>
        </div>
    );
}